module.exports = __webpack_public_path__ + "static/media/08-Knightsbridge.ebbdc61e.mp4";